import {CREATE_STUDENT, FETCH_STUDENT_DATA, UPDATE_STUDENT_TYPE} from '../constants/student';

export function fetchStudentData() {
  return ({
    type: FETCH_STUDENT_DATA,
    api: true,
    auth: true,
    payload: {
      method: 'GET',
      url: '/students/student'
    }
  });
}

export function createStudent(data) {
  return ({
    type: CREATE_STUDENT,
    api: true,
    auth: true,
    payload: {
      method: 'POST',
      url: '/students/students',
      data
    }
  });
}

export function updateStudentType(typeId) {
  return ({
    type: UPDATE_STUDENT_TYPE,
    api: true,
    auth: true,
    payload: {
      method: 'PATCH',
      url: '/students/student',
      data: {type: typeId}
    }
  });
}
